var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuRev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 260,
    viewBox: "0 0 169.33 68.792",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -228.21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.256 90.474)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 29.58 62.971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#5d6ad8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5639 0 0 1.5639 -7.9529 62.971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 16h8v2h-8zm0-4h8v2h-8zm6-10h-8c-1.1 0-2 0.9-2 2v16c0 1.1 0.89 2 1.99 2h12.01c1.1 0 2-0.9 2-2v-12zm4 18h-12v-16h7v5h5z",
    fill: "#e37575"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99957 0 0 .99957 -20.031 83.829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#dd5858"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m90.291 64.772c-6.2402 0-11.264 5.0237-11.264 11.264 0 2.756 0.98093 5.2735 2.6128 7.227-0.40355 2.0536-1.7319 5.2521-5.6208 9.4315 7.9913-2.2639 12.502-4.7753 13.583-5.4172 0.22801 0.0137 0.4573 0.0227 0.68885 0.0227h21.556c6.2402 0 11.264-5.0237 11.264-11.264 0-6.2402-5.0237-11.264-11.264-11.264zm1.726 8.6181a2.6458 2.6458 0 0 1 2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458-2.6458 2.6458 2.6458 0 0 1 2.6458-2.6458zm9.0522 0a2.6458 2.6458 0 0 1 2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458-2.6458 2.6458 2.6458 0 0 1 2.6458-2.6458zm9.0522 0a2.6458 2.6458 0 0 1 2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458 2.6458 2.6458 2.6458 0 0 1-2.6458-2.6458 2.6458 2.6458 0 0 1 2.6458-2.6458z",
    fill: "#868fe2",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90311 0 0 .90311 -29.757 69.644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 4-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuRev);
export default __webpack_public_path__ + "static/media/stu-rev.9e941ab5e20542b4691f0a1e2f901d0b.svg";
export { ForwardRef as ReactComponent };